import request from '../utils';

const getError = (formdata) => new Promise((resolve) => {
  const url = '/api/notification/error';
  const tempData = request.Api(url, formdata, 'post');
  tempData.then((_rawData) => {

    resolve({
      data: _rawData.data.data,
      count: _rawData.data.summary.totalRecordCount,
    });
  });
});

const getErrorTime = (formdata) => new Promise((resolve) => {
  const url = '/api/notification/device';
  const tempData = request.Api(url, formdata, 'post');
  tempData.then((_rawData) => {
    resolve({
      data: _rawData.data.data,
      count: _rawData.data.totalRecordCount,
    });
  });
});
export default {
  getError,
  getErrorTime,
};
